import { motion } from "framer-motion";
import { Phone, MessageCircle, MapPin, BadgeCheck } from "lucide-react";
import { HERO_IMAGE, PHONE_TEL, WHATSAPP_URL } from "./data";

export const Hero = () => (
    <section id="home" data-testid="hero-section" className="relative flex min-h-[92vh] items-center">
        <img
            src={HERO_IMAGE}
            alt="Bridal makeup artist in Chennai – Monisha Makeover Artistry bridal look"
            className="absolute inset-0 h-full w-full object-cover object-[center_30%]"
            loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/20" />
        <div className="relative mx-auto w-full max-w-6xl px-5 py-24">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="max-w-2xl"
            >
                <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">
                    Monisha Makeover Artistry
                </p>
                <h1 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
                    Bridal Makeup Artist in Chennai –{" "}
                    <span className="font-medium italic text-[#E6B8B8]">Book Your Dream Look</span>
                </h1>
                <p className="mt-6 text-base font-medium text-white/90 sm:text-lg">
                    HD Bridal Makeup | Muhurtham Specialist | Home Service Available
                </p>
                <p className="mt-3 inline-flex items-center gap-2 text-sm text-white/75">
                    <MapPin className="h-4 w-4 text-[#D4AF37]" />
                    Serving Chennai &amp; Thiruninravur
                </p>
                <div className="mt-9 flex flex-col gap-4 sm:flex-row">
                    <a
                        href={PHONE_TEL}
                        data-testid="hero-call-button"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-9 py-4 text-base font-extrabold text-[#2C2A29] shadow-xl transition-transform duration-200 hover:-translate-y-1"
                    >
                        <Phone className="h-5 w-5" />
                        Call Now
                    </a>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-whatsapp-button"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-9 py-4 text-base font-extrabold text-white shadow-xl transition-transform duration-200 hover:-translate-y-1"
                    >
                        <MessageCircle className="h-5 w-5" />
                        WhatsApp Now
                    </a>
                </div>
                <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 bg-black/30 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#E6B8B8] backdrop-blur-sm">
                    <BadgeCheck className="h-4 w-4 text-[#D4AF37]" />
                    Limited wedding slots available this season
                </p>
            </motion.div>
        </div>
    </section>
);
